import React, { useRef } from "react";
import axios from "axios";
import style from './Form.module.css'
function Form({ setdone, done }) {
  const firstname = useRef();
  const lastname = useRef();
  const age = useRef();
  const marks = useRef();
  const address=useRef();
  const contact=useRef();
  const sendIt = () => {
    axios
      .post("https://66ed69c7380821644cdcbca5.mockapi.io/todolist", {
        FirstName: firstname.current.value,
        LastName: lastname.current.value,
        Age: age.current.value,
        Marks: marks.current.value,
        Address:address.current.value,
        Contact:contact.current.value
      })
      .then((success) => {
        if (success) {
          setdone(!done);
        }
      })
      .then((error) => {
        if (error) {
          setdone(!done);
        }
      });
  };
  return (
    <div className="container">
        
      <div className="row py-4">
      <h2 className={style.h2_heading}>Enter Student Details here...</h2>
        <div className="col-sm-6">
          <input
            className="form-control mb-2"
            type="text"
            placeholder="Enter FirstName"
            ref={firstname}
          />
          <input
            className="form-control mb-2"
            type="text"
            placeholder="Enter LastName"
            ref={lastname}
          />
           <input
            className="form-control mb-2"
            type="text"
            placeholder="Enter Address"
            ref={address}
          />
        </div>
        <div className="col-sm-6">
          <input
            className="form-control mb-2"
            type="number"
            placeholder="Enter Age"
            ref={age}
          />
          <input
            className="form-control mb-2"
            type="number"
            placeholder="Enter Marks"
            ref={marks}
          />
           <input
            className="form-control mb-2"
            type="text"
            placeholder="Enter Contact"
            ref={contact}
          />
        </div>
        <div className="col-12">    
        <button className="btn btn-success mb-3" onClick={sendIt}>
          Send Data
        </button>
        </div>
      </div>
    </div>
  );
}

export default Form;
